/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./turn.vue?vue&type=template&id=3bf4137f&scoped=true"
import script from "./turn.vue?vue&type=script&lang=js"
export * from "./turn.vue?vue&type=script&lang=js"
import style0 from "./turn.vue?vue&type=style&index=0&id=3bf4137f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf4137f",
  null
  
)

export default component.exports